import { useTheme as useMuiTheme } from '@mui/material/styles';

/**
 * Hook personalizado para acceder al theme de Material-UI
 * Proporciona acceso fácil a colores, espaciado, y otras variables del theme
 */
export const useTheme = () => {
  const theme = useMuiTheme();
  const roleBranding = theme.custom?.roleBranding ?? {};

  return {
    theme,
    // Acceso directo a colores personalizados
    colors: theme.custom.colors,
    neutrals: theme.custom.neutrals,
    notificationColors: theme.custom.notificationTypeColors || {},
    taskCompleted: theme.custom.colors?.taskCompleted || {},
    borderRadius: theme.custom.borderRadius,
    spacing: theme.custom.spacing,
    roleBranding,
    roleBadges: theme.custom?.roleBadges || {},
    getRoleBranding: (role) => {
      if (!roleBranding || typeof roleBranding !== 'object') {
        return {};
      }
      return (
        roleBranding[role] ||
        roleBranding.default ||
        roleBranding.superadmin ||
        {}
      );
    },

    // Funciones de utilidad
    getColor: (colorPath) => {
      const paths = colorPath.split('.');
      let result = theme.palette;
      for (const path of paths) {
        result = result[path];
        if (!result) return undefined;
      }
      return result;
    },

    // Helper para crear estilos consistentes
    createBoxShadow: (level = 1) => theme.shadows[level],

    // Helper para espaciado
    sp: (multiplier) => theme.spacing(multiplier),
  };
};

export default useTheme;
